module.exports = __webpack_public_path__ + "static/media/app-title.f2313dee.png";